import React from "react";
import { Grid, Box, Typography, FormControlLabel, Switch } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import PremiumInput from "../../../../Components/Inputs/PremiumInput";
import PremiumSelect from "../../../../Components/Inputs/PremiumSelect";
import CustomPersianDatePicker from "../../../../Components/CustomPersianDatePicker";

const EDUCATION_LEVEL_OPTIONS = [
  { value: "diploma", label: "دیپلم" },
  { value: "associate", label: "فوق دیپلم" },
  { value: "bachelor", label: "لیسانس" },
  { value: "master", label: "فوق لیسانس" },
  { value: "phd", label: "دکتری" },
];

export default function EducationSection({ formik }) {
  const isCurrentlyStudying = Boolean(formik?.values?.is_currently_studying);

  return (
    <Box sx={{ mt: 3, p: 2, bgcolor: "rgba(0,0,0,0.2)", borderRadius: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <SchoolIcon sx={{ color: "#00ffcc" }} />
        <Typography sx={{ color: "#fff", fontWeight: 700 }}>
          سابقه تحصیلی
        </Typography>
      </Box>

      <Box sx={{ p: 2, bgcolor: "rgba(255,255,255,0.05)", borderRadius: 2 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <PremiumSelect
              name="education_level"
              label="مقطع تحصیلی"
              options={EDUCATION_LEVEL_OPTIONS}
              formik={formik}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <PremiumInput
              formik={formik}
              name="field_of_study"
              label="رشته تحصیلی"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <PremiumInput
              formik={formik}
              name="university_or_institution"
              label="نام دانشگاه / موسسه"
            />
          </Grid>

          <Grid size={{ xs: 6, md: 3 }}>
            <CustomPersianDatePicker
              formik={formik}
              name="education_start_date"
              label="تاریخ شروع"
              placeholder="انتخاب تاریخ"
            />
          </Grid>

          <Grid size={{ xs: 6, md: 3 }}>
            <CustomPersianDatePicker
              formik={formik}
              name="education_end_date"
              label="تاریخ پایان"
              placeholder="انتخاب تاریخ"
              disabled={isCurrentlyStudying}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={isCurrentlyStudying}
                  onChange={(e) => {
                    const checked = Boolean(e?.target?.checked);
                    formik?.setFieldValue("is_currently_studying", checked);
                    if (checked) {
                      formik?.setFieldValue("education_end_date", null);
                    }
                  }}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#00ffcc",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#00ffcc",
                    },
                  }}
                />
              }
              label={
                <Typography sx={{ color: "rgba(255,255,255,0.7)" }}>
                  در حال تحصیل
                </Typography>
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <PremiumInput
              formik={formik}
              name="gpa"
              label="معدل (اختیاری)"
              type="number"
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
